import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legalidad',
  templateUrl: './legalidad.component.html',
  styleUrls: ['./legalidad.component.css']
})
export class LegalidadComponent implements OnInit {

  year: number;

  constructor() { }

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

}
